/* REACT PACKAGE IMPORTS */
import { useEffect, useState, useRef } from "react";

import "../styles/Header.css";

/* MUI PACKAGE IMPORTS */
import { IconButton } from "@mui/material";
import WestIcon from "@mui/icons-material/West";
import { useNavigate } from "react-router-dom";
import Modal from "./Modal";

export default function Header({
  paragraph,
  subParagraph,
  title,
  localeDate,
  UTCDate,
  children,
  showBack = false,
}) {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const isSubLoading = subParagraph?.slice(-1) === "~";
  if (isSubLoading) subParagraph = subParagraph.slice(0, -1);

  const handleNavigate = () => {
    navigate("/candidate/assessments");
  };

  return (
    <div>
      <div className="flex justify-between items-center">
        {title ? <h1 className="header-title pt-2">{title}</h1> : ""}
        {showBack && (
          <div>
            <div className="border-1 border-black rounded-full">
              <IconButton
                aria-label="calculator"
                color="inherit"
                onClick={() => setShowModal(true)}
              >
                <WestIcon />
              </IconButton>
            </div>
            <Modal
              setShowModal={setShowModal}
              show={showModal}
              handleSubmit={handleNavigate}
              msg={"Changes that you made may not be saved."}
              button={"Leave"}
              title={"Are you sure you want to leave?"}
            />
          </div>
        )}
      </div>
      {paragraph ? (
        <div className="mx-1 d-lg-flex justify-content-between">
          <div className="d-lg-inline-flex flex-fill align-items-center">
            <p className="my-auto d-inline-block header-paragraph textsecondary-color">
              <em>{paragraph}</em>
            </p>
          </div>
        </div>
      ) : (
        ""
      )}
      {/* {subParagraph ?
        <div className="pb-2 mx-1 d-lg-flex justify-content-between">
          <div className="d-lg-inline-flex flex-fill align-items-center">
            <em>{subParagraph}</em>
            {isSubLoading ? <Spinner size="sm" className="mx-2"/> : null}
          </div>
        </div> :
        ""
      } */}
      {localeDate ? (
        <p className="mb-2">
          <span className="font-bold">Local Time:</span> {localeDate}
        </p>
      ) : (
        ""
      )}
      {UTCDate ? (
        <p className="mb-4">
          <span className="font-bold">UTC:</span> {UTCDate}
        </p>
      ) : (
        ""
      )}
      {children ? <div className="pt-2">{children}</div> : ""}
    </div>
  );
}
